import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import config from './config'
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import ReactGA from "react-ga4";

if (config.app_env === 'production') {
  Sentry.init({
    environment: config.app_env,
    dsn: config.sentry_dsn,
    // integrations: [new BrowserTracing({
    //   tracingOrigins: ["localhost", "monetizemore.com", "app.m2.ai", "pubguru.com", /^\//],
    // })],
    // tracesSampleRate: 1.0,
  });
}

const setGoogleAnalytics = () => {
  // Initialize Google Analytics.
  ReactGA.initialize(config.ga4_measurement_id);
}
setGoogleAnalytics();

const fallBackComponent = ()=> {
  return (<Alert severity="error">
  <AlertTitle>Error</AlertTitle>
  An error has occured. We are notified and we will look into it.
</Alert>)
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={fallBackComponent()}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
